/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
import { Handle, Position } from '@xyflow/react'
import { FaRegTrashAlt } from 'react-icons/fa'
import { Box } from '@chakra-ui/react'

function DropNode({ data, isConnectable }) {
  return (
    <>
      <Box className="custom-node-datahub node-drop">
        <div className="node-header">
          <FaRegTrashAlt size={18} />
          <span>Drop Message</span>
        </div>
        <div className="node-content">
          <div className="node-section">
            <div className="node-value" style={{ textAlign: 'center', opacity: 0.7 }}>
              Message discarded
            </div>
          </div>
        </div>
      </Box>
      <Handle type="target" position={Position.Left} />
    </>
  )
}

export default DropNode
